var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-image",class:{
		'state-expanded': _vm.isExpanded,
	}},[_c('section',{ref:"imageWrapper",staticClass:"image-wrapper"},[_c('img',{ref:"image",attrs:{"alt":_vm.alt,"src":_vm.src},on:{"click":_vm.Handle_OnClick}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }